<template>
    <div class="project-tile">
        <div class="row">
            <div class="col-12 project-headline text-right">
                <h3>{{project.name}}</h3>
                <h4>{{project.genre}} ({{project.length}})</h4>


            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <template v-if="project.group.indexOf('showreel') > -1">
                    <tile-video v-bind:project="project" v-bind:aspectratio="aspectratio"  v-bind:expanded="show" v-on:video-click="toggleProject()"></tile-video>
                </template>
                <template v-else>
                    <tile-slider v-bind:project="project" v-bind:aspectratio="aspectratio"  v-bind:expanded="show" v-on:slider-click="toggleProject()"></tile-slider>
                </template>
            </div>
        </div>
        <div class="row">
                <div :id="'project-text-' +  project.id" class="col-12 collapse project-info" ref="collapse">
                    <div class="description">{{project.description}}</div>
                    <div class="team">{{credits.team}}</div>
                    <div class="festivals">{{project.festivals}}</div>
                </div>
        </div>
    </div>
</template>


<script>
    import $ from 'jquery';
    import TileSlider from "./project/TileSlider.vue";
    import TileVideo from "./project/TileVideo.vue";

    export default {
        name: "project",
        props: {
            project: {},
            aspectratio: {
                default: 3.2,
                type: Number
            }
        },
        data: function () {
            return {
                show: false,
            };

        },

        computed: {
            credits: function () {
                let team = 'Keine Angaben zum Team vorhanden.';
                let tasks = '';

                let names = {
                    regie: 'Regie:',
                    cast: 'Cast:',
                    sounddesign: 'Sounddesign:',
                    producer: 'Produktion:',
                    camera: 'Kamera:',
                    editing: 'Editing:'
                };

                if (this.project.team) {
                    let t = this.project.team;
                    let temp = [];
                    for (const [key, value] of Object.entries(t)){
                        if(value != ""){
                        temp.push(names[key] + ' ' + value);
                        }
                    }
                    team = temp.join(' | ')
                }


                if (this.project.tasks) {
                    let t = this.project.tasks;
                    let temp = [];
                    for (const [key, value] of Object.entries(t)){
                        if(value != ""){
                            temp.push(value);
                        }
                    }
                    tasks = temp.join(' & ') + ': Robin Jünkersfeld';
                }

                let credits = {
                    team: team,
                    tasks: tasks
                };
                return credits;
            }
        },

        components: {
            TileSlider: TileSlider,
            TileVideo: TileVideo
        },
         methods: {
            toggleProject: function () {
                if(!this.show) {
                  this.openProject();
                } else {
                    this.closeProject();
                }
            },

             openProject: function () {
                 this.show = true;
                 $(this.$refs.collapse).collapse('show');
             },

            closeProject: function () {
                if(this.show) {
                    this.show = false;
                    $(this.$refs.collapse).collapse('hide');
                }
            }
        },
        mounted() {
            // Register an event listener when the Vue component is ready
            window.addEventListener('resize', this.closeProject);
        },

        beforeDestroy() {
            // Unregister the event listener before destroying this Vue instance
            window.removeEventListener('resize', this.closeProject);
        }
    };
</script>